import React from 'react';
import NumberPicker from "../../components/widgets/NumberPicker";
import CategoryPicker from "../segments/Rules/CategoryPicker";
import ManufacturerPicker from "../segments/Rules/ManufacturerPicker";

class Rule extends React.Component {
    constructor(props) {
        super(props);

        this.settings = {
            'on_sale': {
                title: 'Product must be on sale',
                isBool: true,
            },
            'price': {
                title: 'Price must be',
                isBool: false,
            },
            'has_attributes': {
                title: 'Product must have attributes',
                isBool: true,
            },
            'quantity': {
                title: 'Product quantity must be',
                isBool: false,
            },
            'category': {
                title: 'Product must',
                browseCategory: true,
            },
            'brand': {
                title: 'Product must',
                browseBrand: true,
            }
        }

        this.renderOutput = this.renderOutput.bind(this);
        this.handleRuleChange = this.handleRuleChange.bind(this);
    }
    rule() {
        return this.settings[this.props.rule.key];
    }

    handleCategoryChange = (type,o,values) => {
        let v = [];

        for(let i in values) {
            if(type == 'manufacturers') {
                v.push(values[i].manufacturer);
            }else{
                v.push(values[i].id);
            }

        }
        v = v.join(',');

        if(v == '') {
            v = false;
        }

        this.props.handleRuleChange(this.props.index,'value',v)
    }

    handleRuleChange(key,value) {
        this.props.handleRuleChange(this.props.index,key,value)
    }

    renderOutput() {
        if(this.rule().isBool) {
            return (
                <select value={this.props.rule.value} onChange={(e) => this.handleRuleChange('value',e.target.value)} className="form-control">
                    <option value={1}>Yes</option>
                    <option value={0}>No</option>
                </select>
            );
        }

        if(this.rule().browseCategory) {
            return (
                <div>
                    <div className="col-sm-3 p-0">
                        <select value={this.props.rule.operator} onChange={(e) => this.handleRuleChange('operator',e.target.value)} className="form-control">
                            <option value="=">be in category</option>
                            <option value="!=">not be in category</option>
                        </select>
                    </div>

                    <div className="col-sm-3 p-0 p-l-5">
                        <select value={this.props.rule.type} onChange={(e) => this.handleRuleChange('type',e.target.value)} className="form-control">
                            <option value="and">match all</option>
                            <option value="or">match one</option>
                        </select>
                    </div>

                    <div className="col-sm-6 p-0 p-l-5">
                        <CategoryPicker handleRuleChange={this.handleCategoryChange}  useExternalId={true} rule={{
                            value:this.props.rule.value,
                            id:false,
                        }} index="categories" />
                    </div>
                </div>
            )
        }

        if(this.rule().browseBrand) {
            return (
                <div>
                    <div className="col-sm-3 p-0">
                        <select value={this.props.rule.operator} onChange={(e) => this.handleRuleChange('operator',e.target.value)} className="form-control">
                            <option value="=">have</option>
                            <option value="!=">not have</option>
                        </select>
                    </div>

                    <div className="col-sm-3 p-0 p-l-5">

                    </div>

                    <div className="col-sm-6 p-0 p-l-5">
                        <ManufacturerPicker handleRuleChange={this.handleCategoryChange} useExternalId={true} rule={{
                            value:this.props.rule.value,
                            id:false,
                        }} index="manufacturers" />

                    </div>
                </div>
            )
        }

        return (
            <div>
                <div className="col-sm-3 p-0">
                    <select value={this.props.rule.operator} onChange={(e) => this.handleRuleChange('operator',e.target.value)} className="form-control">
                        <option value="<=">less or equal to</option>
                        <option value=">=">more or equal to</option>
                    </select>
                </div>

                <div className="col-sm-3 p-0 p-l-5">

                </div>

                <div className="col-sm-6 p-0 p-l-5">
                    <NumberPicker min={1} max={999999} value={this.props.rule.value} handleChange={(e) => this.handleRuleChange('value',e)} />
                </div>
            </div>
        )
    }

    render() {
        return (
            <tr>
                <td>
                    {this.rule().title}
                </td>
                <td>
                    {this.renderOutput()}
                </td>
                <td>
                    <button type="button" className="btn btn-danger" onClick={() => this.props.delete(this.props.index)}><i className="icon wb-trash"></i></button>
                </td>
            </tr>
        );
    }
}

export default Rule;



// WEBPACK FOOTER //
// ./containers/recommendations/Rule.js